import CardSettings from './CardSettings';

export default CardSettings;
